var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_12575_9665",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_12575_9665)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9998 9.0501C12.1331 9.0501 12.2581 9.0709 12.3748 9.1126C12.4915 9.1543 12.5998 9.2251 12.6998 9.3251L17.2998 13.9251C17.4831 14.1084 17.5748 14.3418 17.5748 14.6251C17.5748 14.9084 17.4831 15.1418 17.2998 15.3251C17.1165 15.5084 16.8831 15.6001 16.5998 15.6001C16.3165 15.6001 16.0831 15.5084 15.8998 15.3251L11.9998 11.4251L8.0998 15.3251C7.91647 15.5084 7.68314 15.6001 7.3998 15.6001C7.11647 15.6001 6.88314 15.5084 6.6998 15.3251C6.51647 15.1418 6.4248 14.9084 6.4248 14.6251C6.4248 14.3418 6.51647 14.1084 6.6998 13.9251L11.2998 9.3251C11.3998 9.2251 11.5081 9.1543 11.6248 9.1126C11.7415 9.0709 11.8665 9.0501 11.9998 9.0501Z",
  fill: "currentColor"
}))));
export default SvgChevronUp;